(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kl-trygghet"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kl-delivery')) {
    customElements.define('kl-delivery', class extends HTMLElement {
      connectedCallback() {
        this.headline = this.querySelector('[data-kl-headline]');
        this.window = this.querySelector('[data-kl-window]');
        this.cutoff = (this.dataset.cutoff || '11:00').split(':').map(Number);
        this.days = (this.dataset.days || '1,2,3,4,5').split(',').map(function (d) { return parseInt(d, 10); });
        this.min = parseInt(this.dataset.min || '1', 10);
        this.max = parseInt(this.dataset.max || '3', 10);
        this.morning = this.dataset.morning || '';
        this.pfx = this.dataset.prefix || 'Beräknad leverans';
        this.holidays = (this.dataset.holidays || '').split(',').map(function (d) { return d.trim(); }).filter(Boolean);
        this.names = ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'];
        this.render();
        this.timer = setInterval(this.render.bind(this), 20000);
      }

      disconnectedCallback() { clearInterval(this.timer); }

      now() {
        return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Stockholm' }));
      }

      iso(d) {
        return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      }

      isShipDay(d) {
        return this.days.indexOf(d.getDay()) !== -1 && this.holidays.indexOf(this.iso(d)) === -1;
      }

      addShipDays(from, n) {
        var d = new Date(from), added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          if (this.isShipDay(d)) added++;
        }
        return d;
      }

      gap(now, d) {
        var a = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var b = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        return Math.round((b - a) / 86400000);
      }

      date(d) {
        return d.toLocaleDateString('sv-SE', { day: 'numeric', month: 'short' }).replace(/\.$/, '');
      }

      // Veckodag, eller datum om det ligger längre fram än en vecka
      day(now, d) {
        return this.gap(now, d) <= 6 ? this.names[d.getDay()] : this.date(d);
      }

      // "i morgon bitti", "måndag morgon", eller ett datum
      shipPhrase(now, d) {
        var g = this.gap(now, d);
        if (g === 1) return 'i morgon bitti';
        if (g <= 6) return this.names[d.getDay()] + (this.morning ? ' ' + this.morning : '');
        return this.date(d);
      }

      render() {
        var now = this.now();
        var cut = new Date(now);
        cut.setHours(this.cutoff[0], this.cutoff[1], 0, 0);

        var ms = cut - now;
        // Sluta lova samma dag den sista minuten – "0 min" ser trasigt ut.
        var today = this.isShipDay(now) && ms > 60000;
        var ship = today ? now : this.addShipDays(now, 1);

        var a = this.addShipDays(ship, this.min);
        var b = this.addShipDays(ship, this.max);
        var da = this.day(now, a);
        var db = this.day(now, b);
        var win = da === db
          ? this.pfx + ' ' + (this.gap(now, a) === 1 ? 'i morgon' : da)
          : this.pfx + ' ' + da + '–' + db;

        if (today) {
          var h = Math.floor(ms / 3600000);
          var m = Math.floor((ms % 3600000) / 60000);
          var left = h > 0 ? (m > 0 ? h + ' tim ' + m + ' min' : h + ' tim') : m + ' min';
          if (h < 1) {
            // Sista timmen: flytta upp nedräkningen till rubriken i stället för att färga den.
            this.headline.textContent = 'Skickas idag om du beställer inom ' + left;
            this.window.textContent = win;
          } else {
            this.headline.textContent = 'Skickas idag';
            this.window.textContent = 'Beställ inom ' + left + ' · ' + win.toLowerCase();
          }
        } else {
          this.headline.textContent = 'Skickas ' + this.shipPhrase(now, ship);
          this.window.textContent = win;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
